import { usePermissions } from "../context/PermissionContext";

/**
 * Convenience hook for checking permissions on a single menu key.
 *
 * Usage:
 *   const { canRead, canCreate, canUpdate, canDelete } = usePermission("CHECKLIST");
 *
 * @param {string} menuKey  The menu key to check, e.g. "CHECKLIST_BUILDER"
 * @returns {{ canRead, canCreate, canUpdate, canDelete, loading }}
 */
const usePermission = (menuKey) => {
  const { can, loading } = usePermissions();

  return {
    canRead:   can(menuKey, "read"),
    canCreate: can(menuKey, "create"),
    canUpdate: can(menuKey, "update"),
    canDelete: can(menuKey, "delete"),
    loading,
  };
};

export default usePermission;